import { mapGetters } from 'vuex';

export default {
    name: 'propertySummaryDetails',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp']),
        ...mapGetters('dpp', ['dpp', 'getMortgagePerMonth', 'getEstimatePriceRange', 'getEstimateInfo', 'getEstRentFee']),
        hideEstMonthCost() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule && compliance[0].rule.indexOf('hideEstMonthCost') >= 0;
        },
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        openDisclaimer() {
            if (this.getEstimateInfo && this.getEstimateInfo.type === 'avm') {
                this.$eventBus.$emit('dialog-center', { name: 'dppPopAvm', opt: {}, trigger: this.$options.name });
            } else {
                this.$eventBus.$emit('dialog-center', { name: 'dppPopEst', opt: {}, trigger: this.$options.name });
            }
        },
        perHOAUnit() {
            const compliance = this.getComplianceMethod()();
            if (compliance[0]) {
                if ((compliance[0].rule.indexOf('hideHOAUnitLand') >= 0 && this.dpp.propertyType === 'LAND') || compliance[0].rule.indexOf('hideHOAUnit') >= 0) {
                    return '';
                }
            }
            return '/month';
        },
    },
};
